/**
 * Set environment variables.
 */
const api = {
    protocol: "https://",
    host: "dev-gb-www.loomis.com"
}

global.api = api;